import { render, staticRenderFns } from "./spend_impressions_contribution.vue?vue&type=template&id=42ad344f&scoped=true"
import script from "./spend_impressions_contribution.vue?vue&type=script&lang=js"
export * from "./spend_impressions_contribution.vue?vue&type=script&lang=js"
import style0 from "./spend_impressions_contribution.vue?vue&type=style&index=0&id=42ad344f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ad344f",
  null
  
)

export default component.exports